import addBrandProductOnSuccess from 'root/src/client/logic/tableItem/actions/addBrandProductOnSuccess'
import updateStepsCompleted from 'root/src/client/util/updateStepsCompleted'

export default body => async (dispatch, getState) => {
	dispatch(addBrandProductOnSuccess(body))
	updateStepsCompleted('hasKeysAndProducts', dispatch, getState)
}
